import { MfaTwoFactorMethod } from './mfa-two-factor-method';

export class MfaSetupDetails {

	twoFactorMethod: MfaTwoFactorMethod = MfaTwoFactorMethod.NotSet;
	twoFactorValue: string|null;
	forceTwoFactorValue: boolean;
	merchantKey: number | null;
	username: number | null;
	password: number | null;
	cookieName: string | null;

	constructor() {
		this.twoFactorMethod = MfaTwoFactorMethod.NotSet;
		this.twoFactorValue = null;
		this.forceTwoFactorValue = false;
		this.merchantKey = null;
		this.username = null;
		this.password = null;
		this.cookieName = null;
	}
}
